"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllowanceDialog = exports.allowanceValidationSchema = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const types_1 = require("@framework/types");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const inputs_1 = require("../../../../inputs");
var validation_1 = require("./validation");
Object.defineProperty(exports, "allowanceValidationSchema", { enumerable: true, get: function () { return validation_1.allowanceValidationSchema; } });
const AllowanceDialog = (props) => {
    const { disabledTokenTypes = [] } = props;
    const handleContractChange = (form) => (_event, option) => {
        form.setValue("contractId", option?.id ?? 0, { shouldDirty: true });
        form.setValue("contract.address", option?.address ?? "0x");
        form.setValue("contract.contractType", option?.contractType ?? "0x");
        form.setValue("contract.decimals", option?.decimals ?? 0);
        void form.trigger();
    };
    return ((0, jsx_runtime_1.jsxs)(ui_kit_1.FormGrid, { columns: [3], children: [(0, jsx_runtime_1.jsx)(mui_inputs_core_1.SelectInput, { name: "tokenType", options: types_1.TokenType, disabledOptions: [types_1.TokenType.NATIVE, ...disabledTokenTypes] }), (0, jsx_runtime_1.jsx)(inputs_1.CommonContractInput, { name: "contractId", onChange: handleContractChange, autoselect: true, withTokenType: true, data: {
                    contractType: [types_1.TokenType.ERC20],
                    contractModule: [types_1.ModuleType.HIERARCHY],
                    contractStatus: [types_1.ContractStatus.ACTIVE],
                    excludeFeatures: [types_1.Erc721ContractFeatures.SOULBOUND],
                } }), (0, jsx_runtime_1.jsx)(inputs_1.AmountInput, {})] }));
};
exports.AllowanceDialog = AllowanceDialog;
//# sourceMappingURL=index.js.map